import { render, staticRenderFns } from "./VulnDetailsModalInner.vue?vue&type=template&id=3a1f6111"
import script from "./VulnDetailsModalInner.vue?vue&type=script&lang=js"
export * from "./VulnDetailsModalInner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports